import React from "react";
import { SectionHeading } from "../SectionHeading";
import { Reveal } from "../Reveal";
import { Icon } from "../Icon";
import { BUSINESS_STAGES } from "../../data/content";
import { useLang } from "../../i18n/LanguageContext";

export const BusinessStages = () => {
  const { t } = useLang();
  return (
    <section data-testid="business-stages-section" className="relative py-24 md:py-32 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <SectionHeading overline={t(BUSINESS_STAGES.overline)} title={t(BUSINESS_STAGES.title)} />
        <p className="mt-6 max-w-2xl text-lg text-white/55 leading-relaxed">{t(BUSINESS_STAGES.sub)}</p>
        <div className="mt-14 grid gap-6 md:grid-cols-3">
          {BUSINESS_STAGES.items.map((item, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div data-testid={`business-stage-${i}`} className="h-full rounded-2xl border border-white/[0.07] bg-[#0A0E17] p-8">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/[0.03] text-[#60A5FA]">
                  <Icon name={item.icon} className="h-5 w-5" />
                </div>
                <h3 className="mt-6 text-xl font-medium tracking-tight text-white">{t(item.name)}</h3>
                <p className="mt-3 text-white/50 leading-relaxed">{t(item.desc)}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
